import React, { useState } from 'react';
import { capitalize, lowerCase } from 'lodash';
import { compose } from 'react-apollo';
import { Button, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import NotificationCountdown from 'components/NotificationCountdown';
import { getUserData } from 'utils/graphQLFunctions';
import TournamentIcon from 'resources/FeatureIcons/Button-Tournaments.svg';
import DesktopNotification from '../DesktopNotification';
import './TournamentStartSoon.css';

function TournamentStartSoon({
  tournamentId,
  startTime,
  locations,
  userData,
  ...rest
}) {
  const [show, setShow] = useState(false);
  const preferredLocation = userData?.user?.preferredLocation;
  const isPreferredLocation = locations.find(
    location =>
      lowerCase(location).replace(/ /g, '') ===
      lowerCase(preferredLocation).replace(/ /g, '')
  );
  const link = !isPreferredLocation ? 'profile' : `/tournament/${tournamentId}`;

  return (
    <>
      <DesktopNotification
        className="notification-tournament-start-soon"
        title={
          <NotificationCountdown
            text={'Tournament begins in '}
            time={startTime}
            onClose={rest.onClose}
            notificationId={rest.notificationId}
          />
        }
        content={
          'A tournament is about to start. Join now and get ready to spin!'
        }
        iconSrc={TournamentIcon}
        footer={
          <Link
            className="btn btn-success notification-tournament-start-soon-button"
            to={link}
            onClick={e =>
              !!isPreferredLocation
                ? rest.onClose(rest.notificationId)
                : setShow(true)
            }
          >
            <span>Join</span>
          </Link>
        }
        {...rest}
      />
      <Modal
        show={show}
        bakgrop="static"
        className="tournament-start-soon-modal"
      >
        <Modal.Body>
          <div className="tournament-start-soon-modal-content">
            This tournament is for{' '}
            {locations.map(location => capitalize(location)).join(', ')}{' '}
            location. Please update your location to join the tournament.
          </div>
          <div className="tournament-start-soon-modal-button">
            <Button
              onClick={() => {
                rest.onClose(rest.notificationId);
                setShow(false);
              }}
            >
              Close
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default compose(
  getUserData({
    name: 'userData'
  })
)(TournamentStartSoon);
